import axios from "axios";
import AuthStore from "../stores/AuthStore";

/**
 * API Manager for handling HTTP requests to the backend
 * Provides methods for authenticated and unauthenticated requests
 */
class apiManager {

  /** @type {string} Base API URL for all requests */
  apiUrl = 'https://demo-api.selffix.co/api/v1/';
  // apiUrl = 'https://v2selffixapi.monkeysteam.com/api/v1/';
  // this.apiUrl = 'http://192.168.0.181:3000/api/v1/';
  // this.apiUrl = 'http://78.188.219.8:3000/api/v1/';

  /**
   * Initialize the API manager
   * Sets the base URL for API requests
   */
  constructor() {

  }

  /**
   * Make HTTP request without authentication token
   * Used for login and public endpoints
   * @async
   * @param {string} url - API endpoint URL
   * @param {string} method - HTTP method (GET, POST, PUT, DELETE)
   * @param {Object} data - Request payload data
   * @returns {Promise<Object>} API response data
   */
  async requestWithoutToken(url, method, data) {

    try {
      const response = await axios({
        url: this.apiUrl + url,
        method,
        data,
      });

      return response.data;
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message || 'Something went wrong',
      };
    }

  }

  /**
   * Make authenticated HTTP request with JWT token
   * Automatically handles token refresh and error responses
   * @async
   * @param {string} url - API endpoint URL
   * @param {string} method - HTTP method (GET, POST, PUT, DELETE)
   * @param {Object} data - Request payload data
   * @returns {Promise<Object>} API response data
   */
  async request(url, method, data) {

    const token = AuthStore.getToken();
    var params = '';

    if (method === 'GET' && data) {
      params = `?${Object.entries(data.params).map(([key, value]) => `${key}=${value}`).join('&')}`;
    }

    try {
      const response = await axios({
        url: this.apiUrl + url + params,
        method,
        data,
        headers: {
          Authorization: `${token}`,
        },
      });

      return response.data;
    } catch (error) {
      // console.log("🚀 ~ ApiManager.js:49 ~ apiManager ~ request ~ error:", error);

      if (error.status === 401) {
        AuthStore.removeToken()
        window.location.href = '/tech/login';
      }
      return {
        success: false,
        message: error?.response?.data?.message ? error.response.data.message : 'Something went wrong',
      };
    }
  }

  /**
   * Upload file with multipart form data
   * Used for file uploads with authentication
   * @async
   * @param {string} url - Upload endpoint URL
   * @param {FormData} body - FormData object containing file and metadata
   * @returns {Promise<Object>} Upload response data
   */
  async uploadFile(url, body) {
    const token = AuthStore.getToken();

    const response = await axios({
      url: `${this.apiUrl}${url}`,
      method: 'post',
      data: body,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `${token}`,
      },
    });
    return response.data;
  }
}

const ApiManager = new apiManager();

export default ApiManager;